import { render, staticRenderFns } from "./ExternalBillOfLadingEdit.vue?vue&type=template&id=5451bfe6&"
import script from "./ExternalBillOfLadingEdit.vue?vue&type=script&lang=js&"
export * from "./ExternalBillOfLadingEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports